import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';

import { Props } from '@/pages/Profile/components/HideCardModal/types';
import { Modal } from '@/ui';

/**
 * Confirms hiding a card, and says up front how to get it back: a hidden card is easy to lose
 * track of once it is out of sight.
 */
const HideCardModal = ({ cardTitle, editingRoleName, onClose, onConfirm }: Props) => {
  // Held on to while the modal animates closed, so the copy doesn't blank out mid-fade.
  const [title, setTitle] = useState(cardTitle);
  useEffect(() => {
    if (cardTitle) setTitle(cardTitle);
  }, [cardTitle]);

  return (
    <Modal
      description={
        editingRoleName
          ? `You're editing the ${editingRoleName} default, so once you save, ${title} is hidden for everyone following it who hasn't arranged their own cards.`
          : `${title} moves to the bottom of this page, out of the way of the cards you use.`
      }
      icon={<FontAwesomeIcon className="text-uniform-gray-500" icon={faEyeSlash} />}
      open={cardTitle !== null}
      primaryAction={{ label: 'Hide card', onClick: onConfirm }}
      secondaryAction={{ label: 'Cancel', onClick: onClose }}
      size="sm"
      title={`Hide ${title}?`}
      onClose={onClose}>
      <div className="rounded-lg bg-uniform-gray-50 p-3 text-sm text-uniform-gray-700 dark:bg-uniform-gray-800 dark:text-uniform-gray-300">
        <p className="font-medium">To bring it back</p>
        <p className="mt-1">
          Open the <strong>cards hidden</strong> line at the bottom of the page, then choose{' '}
          <strong>Unhide</strong> on the card.
        </p>
      </div>
    </Modal>
  );
};

export default HideCardModal;
